import React from "react";
import OSLineChart from "../Graphs/Other_statistics/OS_LineChart";
import OSUserDetails from "../Graphs/Other_statistics/OS_UserDetails";
export interface IOth_StatisticsProps {
  dbData: any;
}
const Oth_Statistics: React.FC<IOth_StatisticsProps> = (props) => {
  return (
    <div className="oth_Statistics">
      <div className="oth_Statistics_row_one">
        <div className="Graph_col oth_Statistics_col_one">
          <OSLineChart dbData={props.dbData} />
        </div>
        <div className="oth_Statistics_col_two">
          <OSUserDetails dbData={props.dbData} />
        </div>
      </div>
    </div>
  );
};

export default Oth_Statistics;
